(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-marketing/assets/javascripts/components/searchbar.js') >= 0) return;  svs.modules.push('/modules/grassroots-marketing/assets/javascripts/components/searchbar.js');

'use strict';

const {
  Form,
  ControlGroup,
  Input
} = svs.ui.reactForm;
const {
  links
} = svs.grassroots;
const {
  ListGroup,
  ListItemLink
} = svs.ui.ReactListGroup;
const {
  Link
} = svs.app.ReactRouter;
const {
  ReactBadge: Badge,
  ReactIcon
} = svs.ui;
const Item = _ref => {
  let {
    longname,
    subcategory,
    supporters,
    points
  } = _ref;
  return React.createElement("div", {
    className: "grid-row"
  }, React.createElement("div", {
    className: "col-xs-12 col-md-7 align-left"
  }, React.createElement("div", null, longname, subcategory === '' ? React.createElement(Badge, {
    branding: "gray",
    className: "roundbadge padding-h margin-left"
  }, "Huvudf\xF6rening") : " - ".concat(subcategory))), React.createElement("div", {
    className: "col-xs-12 col-md-5 padding-xs-top padding-md-0"
  }, React.createElement("span", {
    className: "padding-xs-right padding-md-right-3"
  }, React.createElement(ReactIcon, {
    icon: "person"
  }), React.createElement("span", {
    className: "details-font"
  }, "".concat(supporters, " st"))), React.createElement("span", null, React.createElement(ReactIcon, {
    icon: "points"
  }), React.createElement("span", {
    className: "details-font"
  }, "".concat(points, " p")))));
};
const ListLinksMap = _ref2 => {
  let {
    searchResult
  } = _ref2;
  return searchResult === null || searchResult === void 0 ? void 0 : searchResult.map(_ref3 => {
    let {
      longname,
      id,
      shortname,
      subcategory,
      supporters,
      points
    } = _ref3;
    return React.createElement(ListItemLink, {
      className: "search-item",
      key: id
    }, React.createElement(Link, {
      to: links.single(id, shortname)
    }, React.createElement(Item, {
      longname,
      subcategory,
      supporters,
      points
    })));
  });
};
const ListItemsMap = _ref4 => {
  let {
    searchResult,
    onClick
  } = _ref4;
  return searchResult === null || searchResult === void 0 ? void 0 : searchResult.map(_ref5 => {
    let {
      longname,
      id,
      shortname,
      subcategory,
      supporters,
      points
    } = _ref5;
    return React.createElement(ListItemLink, {
      className: "search-item",
      key: id
    }, React.createElement("a", {
      href: "#",
      onClick: () => onClick({
        longname,
        shortname,
        subcategory,
        id
      })
    }, React.createElement(Item, {
      longname,
      subcategory,
      supporters,
      points
    })));
  });
};
const Searchbar = _ref6 => {
  let {
    onSubmit,
    onChange,
    onBlur,
    searchResult,
    searchterm,
    displayResults,
    onClick
  } = _ref6;
  return React.createElement("div", {
    className: "searchbar-container margin-top-2"
  }, React.createElement(Form, {
    isVertical: true,
    onSubmit: onSubmit
  }, React.createElement(ControlGroup, null, React.createElement(Input, {
    autoComplete: "off",
    className: "searchbar-input",
    id: "searchbar",
    label: "S\xF6k p\xE5 f\xF6reningens namn, idrott, ort eller l\xE4n. Du kan \xE4ven kombinera s\xF6kkriterierna.",
    onBlur: onBlur,
    onChange: onChange,
    placeholder: "S\xF6k",
    size: "large",
    type: "text",
    value: searchterm
  })), displayResults && (searchResult === null || searchResult === void 0 ? void 0 : searchResult.length) > 0 && React.createElement(ListGroup, {
    className: "search-suggestions form-vertical"
  }, !onClick && React.createElement(ListLinksMap, {
    searchResult
  }), onClick && React.createElement(ListItemsMap, {
    searchResult,
    onClick
  }))));
};
svs.grassroots.components.Searchbar = Searchbar;

 })(window);